SlideView = require("views/slide")
{ Sound } = Application.actions()

class ImageWaypointsView extends SlideView
  template: require("./template")

  events:
    "iostap .btn-done": "submit"
    "iostap .prev-wp": "goToPrevWaypoint"
    "iostap .next-wp": "goToNextWaypoint"
    "iostap .waypoint": "tapWaypoint"
    "iostap": "exitWaypoint"

  serialize: ->
    data = super
    data.hasPrompt = true

    for waypoint in data.waypoints
      waypoint.center = @getCenter(waypoint.region)

    data

  submit: (e) ->
    e?.stopImmediatePropagation()
    super

  beforeHide: ->
    @trigger("ui", lightbox: false)
    @exitWaypoint()
    @sendAudioTemplateAudio(null,false)

  hide: ->
    @el.classList.remove("is-loaded")

  refresh: (params) ->
    for { caption }, i in params.data.waypoints
      changed = i unless caption is @options.data.waypoints[i]?.caption

    super

    @beforeShow()
    @show(false)

    if changed?
      @el.classList.add "no-transition"
      @goToWaypoint(changed)
      _.delay (=> @el.classList.remove "no-transition"), 1

  onRefresh: ->

  onResize: ->
    if @getEl("container")
      @getEl("container").style.height = ""
      @getEl("container").style.width = ""
      @getEl("container").parentNode?.style.height = ""
    @setDimensions()

  beforeShow: ->
    @setState(false, "zoom")
    @setState @options.data.guided.toString(), "guided"

    if @options.data.guided
      @showLightbox()
    else
      @trigger("ui", lightbox: false)

  setTextColor: (lightbox) ->
    if color = lightbox?.textColor?.toLowerCase()
      @el.style.color = lightbox?.textColor?.toLowerCase()

  setWaypointColor: (appearance) ->
    if color = appearance?.waypointColor?.toLowerCase()
      # Remove all existing style-option classes
      @el.classList.remove("waypoint-black", "waypoint-white")
      @el.classList.add("waypoint-#{color}")

  showLightbox: ->
    @setState(true, "zoom")
    @trigger("ui", lightbox: @options.data.lightbox?.background or true)

  show: (fadeImage = true) ->
    @setEl img = @findOne(".img"), "image"
    @setEl @findOne(".caption"), "caption"
    @setEl @findOne(".waypoints"), "waypoints"
    @setEl @findOne(".navigation"), "navigation"
    @setEl @findOne(".image-container"), "container"

    @setState("prompt")
    @setState(false, "zoom")
    @setState @options.data.guided.toString(), "guided"

    @setTextColor(@options.data.lightbox)
    @setWaypointColor(@options.data.appearance)
    @listenTo this, "resize", @onResize

    if not fadeImage
      @el.classList.add "no-transition"

    if img?.complete
      @resetImageScale()
      @setDimensions()
    else if img?
      img.onload = => 
        @resetImageScale()
        @setDimensions()

  resetImageScale: ->
    @transform @getEl("image"), "none"

  setDimensions: ->
    @setContainerDimensions()
    @el.classList.add("is-loaded")

    if @options.data.guided
      @goToWaypoint 0

    @el.offsetLeft
    @el.classList.remove "no-transition"

  getCenter: (wp) ->
    x: (wp.xMin + wp.xMax) / 2
    y: (wp.yMin + wp.yMax) / 2

  allWaypointsTapped: ->
    _.reduce @getEl("waypoints").children, (allTapped, el) ->
      allTapped and el.dataset.tapped
    , true

  tapWaypoint: (e) ->
    el = e.target
    e.stopImmediatePropagation()

    @goToWaypoint +el.dataset.index

    el.dataset.tapped = "true"
    el.classList.add "tapped"

    if @allWaypointsTapped()
      @setState("touched")

  goToPrevWaypoint: (e) ->
    e.stopImmediatePropagation()
    @goToWaypoint Math.max @currentIndex - 1, @limits().min

  goToNextWaypoint: (e) ->
    e.stopImmediatePropagation()
    @goToWaypoint Math.min @currentIndex + 1, @limits().max

  updateNextPrevButtons: ->
    if @options.data.guided
      { min, max } = @limits()
      @el.classList.toggle("prev-disabled", @currentIndex is min)
      @el.classList.toggle("next-disabled", @currentIndex is max)
      @setState("touched") if @currentIndex is max

  limits: ->
    min: 0
    max: @options.data.waypoints.length - 1

  goToWaypoint: (@currentIndex) ->
    { region, caption, narration } = @options.data.waypoints[@currentIndex]
    loaded = false

    if (@currentSrc = narration) and not @withoutNarration
      @sendAudioTemplateAudio(@currentSrc, true)
    else
      @sendAudioTemplateAudio(null, true)

    @showLightbox()
    @updateNextPrevButtons()
    @toggleCaption(caption)
    @scaleImage(region)

  exitWaypoint: ->

    if not @options.data.guided
      @sendAudioTemplateAudio(null, true)
      @toggleCaption()
      @setState(false, "zoom")
      @trigger("ui", lightbox: false)
      @resetImageScale()

  scaleImage: (region, zoomed = true) ->
    image     = @getEl("image")
    navBounds = @getEl("navigation").getBoundingClientRect()
    { x, y } = @getCenter(region)

    viewportWidth  = @el.offsetWidth
    # 150 height of navigation
    viewportHeight = if zoomed || @options.data.guided then window.innerHeight - 150 else @el.offsetHeight
    # get the highlighted region's dimension
    regionWidth    = (region.xMax - region.xMin) * image.width #size in px
    regionHeight   = (region.yMax - region.yMin) * image.height #size in px
    # zoom image relative to the highlighted region
    widthScale     = viewportWidth / regionWidth
    heightScale    = viewportHeight / regionHeight
    @scaleToUse    = parseFloat(Math.min(widthScale, heightScale))
    # move highlighted region to the center of the screen
    # 50% is to center the region, similar to this trick {position: relative; top: 50%; left: 50%}
    translateX     = -x * 100 * @scaleToUse + 50 + "%"
    translateY     = -y * 100 * @scaleToUse + 50 + "%"
    @transform image, "translateX(#{translateX}) translateY(#{translateY}) scale(#{@scaleToUse})"

  toggleCaption: (caption = false) ->
    @setState(Boolean(caption), "caption")
    @getEl("caption").innerHTML = caption or ""

    if not caption?
      @getEl("caption").style.background = ""
    else if @options.data.lightbox?.background
      @getEl("caption").style.background = @options.data.lightbox.background

  setContainerDimensions: ->
    img = @getEl("image")
    parentContainer = @getEl("container").parentNode.parentNode
    return unless img? and parentContainer?

    if img.width == 0 || img.height == 0 
      # if image width/height is not detected, follow parent container's dimension
      # this case is possible in firefox for svg without explicit width/height
      if parentContainer.offsetWidth < parentContainer.offsetHeight
        @getEl("container").style.width = "#{parentContainer.offsetWidth}px"
      else
        @getEl("container").style.height = "#{parentContainer.offsetHeight}px" 
      return

    widthScale = parentContainer.offsetWidth / img.width
    heightScale = parentContainer.offsetHeight / img.height
    scale = Math.min(widthScale, heightScale)
    scaledContainer  = {
      width: img.width * scale
      height: img.height * scale
    }
    @getEl("container").style.width = "#{scaledContainer.width}px"
    @getEl("container").style.height = "#{scaledContainer.height}px"

  onNarrationComplete: ->
    # show cotinue button after narration is complete
    @setState("") # reset previous state, this is how it's always done previously
    @setState("touched")

module.exports = ImageWaypointsView
